import {MitEventBus} from '../../main.js';

class BaseMitPageLoadingService {
  constructor() {
    this.isLoading = false;
    this.isPageLoading = false;
  }

  showLoading(loading, message, spinnerSize){
    this.isLoading = loading;
    message = message || 'Loading...';
    spinnerSize = spinnerSize || 88;
    MitEventBus.$emit('mit-pageloadingservice--loading-changed', { loading: loading, message: message, loadingSize:spinnerSize, loadingProgressBar:false });
  }
  showLoadingBar(loading, message){
    this.isLoading = loading;
    message = message || 'Loading...';
    MitEventBus.$emit('mit-pageloadingservice--loading-changed', { loading: loading, message: message, loadingSize:88, loadingProgressBar:true });
  }

  hideLoading(){
    this.isLoading = false;
    MitEventBus.$emit('mit-pageloadingservice--loading-changed', { loading: false, message: 'Loading...', loadingSize:88, loadingProgressBar:false });
  }
  /*
  * getLoadingState - will get a value from the config
  */
  getLoadingState(){
    return this.isLoading;
  }

}
//This sets this service up like a singlton object.
export default new BaseMitPageLoadingService();
